import React from 'react';

const BinaryCode = () => {
  return (
    <div className="binary-code" aria-hidden="true">
      01011001
    </div>
  );
};

export default BinaryCode;